export default {
	nome_column_not_found: "Arquivo não contém a coluna 'nome'. Verifique se o nome da coluna está correto, sem erros de digitação ou espaços extras, e tente novamente",
	numero_column_not_found: "Arquivo não contém a coluna 'numero'. Verifique se o nome da coluna está correto, sem erros de digitação ou espaços extras, e tente novamente.",
	all_columns_not_found: "Nenhuma das colunas requiridas foram encontradas, verifique se o arquivo está separado por vírgula ou ponto e vírgula"
}
